module.exports = __webpack_public_path__ + "img/coursenone.48453774.png";